import React from 'react';
import { DotNotificationProps } from '../../types/components/shared/DotNoitficationTypes';

const DotNotification: React.FC<DotNotificationProps> = ({
  position = 'inline',
  top,
  right,
  left,
  bottom,
  className = '',
  outerSize = 'w-[12px] h-[12px]',
  innerSize = 'w-[8px] h-[8px]',
  outerColor = 'bg-[#15191B]',
  innerColor = 'bg-[#24C1FF]',
  animate = true
}) => {
  const animationClass = animate ? 'animate-pulse' : '';

  const positioningClass = position === 'absolute'
    ? 'absolute'
    : 'inline-flex items-center justify-center';

  const positionStyles: React.CSSProperties = {};
  if (position === 'absolute') {
    if (top) positionStyles.top = top;
    if (right) positionStyles.right = right;
    if (left) positionStyles.left = left;
    if (bottom) positionStyles.bottom = bottom;
  }

  return (
    <div
      cy-test-id="dot-notification"
      className={`${positioningClass} ${position === 'inline' ? 'ml-2' : ''} ${className}`}
      style={positionStyles}
    >
      <div className={`${outerSize} rounded-full ${outerColor} flex justify-center items-center`}>
        <div className={`${innerSize} rounded-full ${innerColor} ${animationClass}`}></div>
      </div>
    </div>
  );
};

export default DotNotification;